import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function Footer() {
  return;
}